<template>
  <div id="topo-page">
    <iframe id="topo-frame" src="/topo3d/topo-3d.html" frameborder="0" allowfullscreen></iframe>
    <button class="back-btn" @click="goBack">⬅ 返回大屏</button>
  </div>
</template>

<script>
export default {
  name: 'Topo3D',
  methods: {
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
#topo-page {
  position: fixed;
  inset: 0;
  background: #05060a;
  overflow: hidden;
}
#topo-frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.back-btn {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 999;
  background: rgba(5, 9, 18, 0.72);
  color: #cfe9ff;
  border: 1px solid rgba(90, 180, 255, 0.45);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
  letter-spacing: 0.5px;
  backdrop-filter: blur(4px);
}
.back-btn:hover {
  background: rgba(30, 60, 110, 0.85);
  color: #fff;
}
</style>
